import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import StickyCta from "./components/StickyCta";

import HomePage from "./pages/HomePage";
import OmMigPage from "./pages/OmMigPage";
import AkupunkturPage from "./pages/AkupunkturPage";
import JapanskAkupunkturPage from "./pages/JapanskAkupunkturPage";
import OereAkupunkturPage from "./pages/OereAkupunkturPage";
import VaegtreguleringPage from "./pages/VaegtreguleringPage";
import RygestopPage from "./pages/RygestopPage";
import PriserPage from "./pages/PriserPage";
import KontaktPage from "./pages/KontaktPage";
import FaqPage from "./pages/FaqPage";
import YdelsePage from "./pages/YdelsePage";
import LedOgMuskelsmerterPage from "./pages/LedOgMuskelsmerterPage";
import SpaendingerPage from "./pages/SpaendingerPage";
import OndtIRyggenPage from "./pages/OndtIRyggenPage";
import MigraenePage from "./pages/MigraenePage";
import OndtIKaebenPage from "./pages/OndtIKaebenPage";
import StressPage from "./pages/StressPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForbiddenPage from "./pages/ForbiddenPage";

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-[#fffaf7] font-sans text-[#593427] antialiased selection:bg-[#d74814] selection:text-white relative overflow-x-hidden w-full max-w-full">
        <ScrollToTop />
        <Navbar />

        <main className="flex-grow relative z-10">
          <Routes>
            {/* Forside */}
            <Route path="/" element={<HomePage />} />

            {/* Om mig */}
            <Route path="/om-mig" element={<OmMigPage />} />
            <Route path="/om-mig/" element={<OmMigPage />} />

            {/* Behandlinger */}
            <Route path="/akupunktur" element={<AkupunkturPage />} />
            <Route path="/akupunktur/" element={<AkupunkturPage />} />

            {/* Akupunktur undersider */}
            <Route path="/stress" element={<StressPage />} />
            <Route path="/stress/" element={<StressPage />} />
            <Route path="/akupunktur/stress" element={<StressPage />} />
            <Route path="/akupunktur/stress/" element={<StressPage />} />

            <Route path="/spaendinger" element={<SpaendingerPage />} />
            <Route path="/spaendinger/" element={<SpaendingerPage />} />
            <Route path="/muskelspaendinger" element={<SpaendingerPage />} />
            <Route path="/muskelspaendinger/" element={<SpaendingerPage />} />
            <Route path="/akupunktur/spaendinger" element={<SpaendingerPage />} />
            <Route path="/akupunktur/spaendinger/" element={<SpaendingerPage />} />
            <Route path="/akupunktur/muskelspaendinger" element={<SpaendingerPage />} />
            <Route path="/akupunktur/muskelspaendinger/" element={<SpaendingerPage />} />

            <Route path="/ondt-i-ryggen" element={<OndtIRyggenPage />} />
            <Route path="/ondt-i-ryggen/" element={<OndtIRyggenPage />} />
            <Route path="/akupunktur/ondt-i-ryggen" element={<OndtIRyggenPage />} />
            <Route path="/akupunktur/ondt-i-ryggen/" element={<OndtIRyggenPage />} />

            {/* Led og muskelsmerter undersider */}
            <Route path="/led-og-muskelsmerter" element={<LedOgMuskelsmerterPage />} />
            <Route path="/led-og-muskelsmerter/" element={<LedOgMuskelsmerterPage />} />
            <Route path="/led-og-muskel-smerter" element={<LedOgMuskelsmerterPage />} />
            <Route path="/led-og-muskel-smerter/" element={<LedOgMuskelsmerterPage />} />
            <Route path="/akupunktur/led-og-muskelsmerter" element={<LedOgMuskelsmerterPage />} />
            <Route path="/akupunktur/led-og-muskelsmerter/" element={<LedOgMuskelsmerterPage />} />

            <Route path="/japansk-akupunktur" element={<JapanskAkupunkturPage />} />
            <Route path="/japansk-akupunktur/" element={<JapanskAkupunkturPage />} />

            {/* Japansk akupunktur undersider */}
            <Route path="/migraene" element={<MigraenePage />} />
            <Route path="/migraene/" element={<MigraenePage />} />
            <Route path="/japansk-akupunktur/migraene" element={<MigraenePage />} />
            <Route path="/japansk-akupunktur/migraene/" element={<MigraenePage />} />

            <Route path="/ondt-i-kaeben" element={<OndtIKaebenPage />} />
            <Route path="/ondt-i-kaeben/" element={<OndtIKaebenPage />} />
            <Route path="/kaebesmerter" element={<OndtIKaebenPage />} />
            <Route path="/kaebesmerter/" element={<OndtIKaebenPage />} />
            <Route path="/japansk-akupunktur/ondt-i-kaeben" element={<OndtIKaebenPage />} />
            <Route path="/japansk-akupunktur/ondt-i-kaeben/" element={<OndtIKaebenPage />} />

            <Route path="/oere-akupunktur" element={<OereAkupunkturPage />} />
            <Route path="/oere-akupunktur/" element={<OereAkupunkturPage />} />

            <Route path="/vaegtregulering" element={<VaegtreguleringPage />} />
            <Route path="/vaegtregulering/" element={<VaegtreguleringPage />} />

            <Route path="/rygestop-behandling" element={<RygestopPage />} />
            <Route path="/rygestop-behandling/" element={<RygestopPage />} />
            <Route path="/rygestopsbehandling" element={<RygestopPage />} />
            <Route path="/rygestopsbehandling/" element={<RygestopPage />} />

            {/* Priser */}
            <Route path="/priser" element={<PriserPage />} />
            <Route path="/priser/" element={<PriserPage />} />

            {/* Kontakt */}
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/kontakt/" element={<KontaktPage />} />

            {/* FAQ / Ofte stillede spørgsmål */}
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/faq/" element={<FaqPage />} />
            <Route path="/spoergsmaal-og-svar" element={<FaqPage />} />
            <Route path="/spoergsmaal-og-svar/" element={<FaqPage />} />

            {/* Ydelse */}
            <Route path="/ydelse" element={<YdelsePage />} />
            <Route path="/ydelse/" element={<YdelsePage />} />

            {/* 403 Forbidden */}
            <Route path="/403" element={<ForbiddenPage />} />

            {/* 404 Not Found (also covers /?page_id=4643) */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <StickyCta />
        <Footer />
      </div>
    </HelmetProvider>
  );
}
